import React, { useState, useImperativeHandle, forwardRef } from 'react';
import logger from '../../lib/logger';
import FloatingText, { EffectType } from '../FloatingText/FloatingText';
import './EffectsCanvas.css';

interface Effect {
  id: number;
  text: string;
  type: EffectType;
  position: { x: number; y: number };
}

export interface EffectsCanvasHandle {
  addEffect: (text: string, type: EffectType, position: { x: number; y: number }) => void;
}

const EffectsCanvas = forwardRef<EffectsCanvasHandle, {}>((props, ref) => {
  const [effects, setEffects] = useState<Effect[]>([]);
  const [effectIdCounter, setEffectIdCounter] = useState(0);

  useImperativeHandle(ref, () => ({
    addEffect(text, type, position) {
      const newId = Date.now() + Math.random();
      logger.info('[EffectsCanvas]', `Adding effect #${newId}: "${text}"`);
      const newEffect: Effect = {
        id: newId,
        text,
        type,
        position,
      };
      setEffects(prevEffects => [...prevEffects, newEffect]);
    },
  }));

  const handleEffectComplete = (id: number) => {
    logger.info('[EffectsCanvas]', `Effect #${id} completed and removed.`);
    setEffects(prevEffects => prevEffects.filter(effect => effect.id !== id));
  };

  // Render directly into the component tree
  return (
    <div className="effects-canvas">
      {effects.map(effect => (
        <FloatingText
          key={effect.id}
          id={effect.id}
          text={effect.text}
          type={effect.type}
          position={effect.position}
          onComplete={handleEffectComplete}
        />
      ))}
    </div>
  );
});

export default EffectsCanvas;
